import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _replaceAllInstanceProperty from "@babel/runtime-corejs3/core-js/instance/replace-all";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import moment from "moment";
import { SET_DOCUMENTS, SET_DOCUMENT_COMMENTS, SET_DOCUMENT_CLASSIFICATIONS, ADD_DOCUMENT_COMMENT, REMOVE_DOCUMENT_COMMENT, EDIT_DOCUMENT_DETAILS, ADD_DOCUMENTS_TO_CLASSIFICATION, ADD_DOCUMENT_TO_REQUEST_CLASSIFICATION, SET_DOCUMENT_CLASSIFICATION_SENT_STATUS, REMOVE_DOCUMENT_FROM_CLASSIFICATION } from "./document-mutations";
import { getDocumentClassifications, downloadDocument, downloadDocumentNoClient, markUploadCompleted, sendComment, updateDocumentStatus, markDocumentRequestUploadCompleted, getSignedURL, deleteDocument, createSignedUrls } from "../api/document-api";
import { normalize } from "normalizr";
import { classificationListSchema } from "./document-schema";
import Err from "@Client/@Routes/error";
import { putS3Data } from "@Shared/utils/ajax";
import { showToast } from "@Shared/utils/constants";
import isPDFEncrypted from "@Shared/utils/is-pdf-encrypted";
import { groupBy, isEmpty } from "lodash";
import { v4 as uuidv4 } from "uuid";
export const LOAD_DOCUMENTS = "LOAD_DOCUMENTS";
export const DOWNLOAD_DOCUMENT = "DOWNLOAD_DOCUMENT";
export const GET_SIGNED_URL = "GET_SIGNED_URL";
export const MARK_UPLOAD_COMPLETED = "MARK_UPLOAD_COMPLETED";
export const SEND_DOCUMENT_COMMENT = "SEND_DOCUMENT_COMMENT";
export const UPLOAD_DOCUMENT_TO_CLASSIFICATION = "UPLOAD_DOCUMENT_TO_CLASSIFICATION";
export const UPDATE_DOCUMENT_STATUS = "UPDATE_DOCUMENT_STATUS";
export const UPLOAD_DOCUMENT_TO_REQUEST_CLASSIFICATION = "UPLOAD_DOCUMENT_TO_REQUEST_CLASSIFICATION";
export const DOWNLOAD_DOCUMENT_NO_CLIENT = "DOWNLOAD_DOCUMENT_NO_CLIENT";
export const UPDATE_DOCUMENT_CLASSIFICATION_SENT_STATUS = "UPDATE_DOCUMENT_CLASSIFICATION_SENT_STATUS";
export const DELETE_DOCUMENT_FROM_CLASSIFICATION = "DELETE_DOCUMENT_FROM_CLASSIFICATION";
const actions = {
  [LOAD_DOCUMENTS]: async (context, {
    applicationId
  }) => {
    try {
      const {
        documents: documentClassifications
      } = await getDocumentClassifications(applicationId);
      const {
        entities: {
          classifications,
          comments,
          documents
        },
        result
      } = normalize(documentClassifications, [classificationListSchema]);
      context.commit(SET_DOCUMENTS, {
        documents: {
          byId: documents || {}
        },
        applicationId
      });
      context.commit(SET_DOCUMENT_COMMENTS, {
        comments: {
          byId: comments || {}
        },
        applicationId
      });
      context.commit(SET_DOCUMENT_CLASSIFICATIONS, {
        classifications: {
          byId: classifications || {},
          allIds: result || []
        },
        applicationId
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [DOWNLOAD_DOCUMENT]: async (context, {
    fileName,
    documentId,
    applicationId
  }) => {
    try {
      const {
        url
      } = await downloadDocument(documentId, fileName, applicationId);
      return {
        url
      };
    } catch (e) {
      Err.handle(e);
    }
  },
  [DOWNLOAD_DOCUMENT_NO_CLIENT]: async (context, {
    fileName,
    documentId
  }) => {
    try {
      const {
        url
      } = await downloadDocumentNoClient(documentId, fileName);
      return url;
    } catch (e) {
      Err.handle(e);
    }
  },
  [GET_SIGNED_URL]: async (context, {
    fileName,
    clientUsername,
    documentRequestId
  }) => {
    try {
      return await getSignedURL(fileName, clientUsername, documentRequestId);
    } catch (e) {
      Err.handle(e);
    }
  },
  [MARK_UPLOAD_COMPLETED]: async (context, {
    applicationId,
    classificationType,
    documentDescription,
    documentS3Key,
    documentRequestId,
    encrypted
  }) => {
    try {
      return await markUploadCompleted(applicationId, classificationType, documentDescription, documentS3Key, documentRequestId, encrypted);
    } catch (e) {
      Err.handle(e);
    }
  },
  [SEND_DOCUMENT_COMMENT]: async (context, {
    applicationId,
    documentId,
    comment,
    senderDetails
  }) => {
    const tempId = moment().unix().toString();
    try {
      const createdAt = moment().format();
      context.commit(ADD_DOCUMENT_COMMENT, {
        comment: _objectSpread({
          id: tempId,
          createdAt,
          comment
        }, senderDetails),
        applicationId,
        documentId
      });
      await sendComment(documentId, {
        comment
      });
    } catch (e) {
      context.commit(REMOVE_DOCUMENT_COMMENT, {
        applicationId,
        documentId,
        commentId: tempId
      });
      Err.handle(e);
    }
  },
  [UPLOAD_DOCUMENT_TO_CLASSIFICATION]: async (context, {
    applicationId,
    classification,
    files,
    fileName,
    notifyUser = true
  }) => {
    try {
      const newDocuments = [];
      const filesData = [];
      for (const file of files) {
        var _context;
        const name = fileName || _replaceAllInstanceProperty(_context = file.name).call(_context, " ", "-");
        filesData.push({
          fileName: name,
          data: file,
          type: file.type,
          url: "",
          documentId: uuidv4()
        });
      }
      const filesInfo = _mapInstanceProperty(filesData).call(filesData, file => ({
        fileName: file.fileName,
        type: file.type,
        size: file.data.size,
        documentId: file.documentId
      }));
      const groupedFilesData = groupBy(filesData, "documentId");
      const signedUrls = await createSignedUrls(filesInfo, applicationId.toString(), classification.documentRequestId);
      for (const {
        url,
        documentId
      } of signedUrls) {
        if (!isEmpty(groupedFilesData[documentId]) && !isEmpty(groupedFilesData[documentId][0])) {
          groupedFilesData[documentId][0].url = url;
        }
      }
      for (const file of filesData) {
        var _file$fileName, _context2;
        let isEncrypted = false;
        const extension = (_file$fileName = file.fileName) == null ? void 0 : _file$fileName.split(".").pop();
        if (extension === "pdf" || file.type === "application/pdf") {
          const PDFEncrypted = await isPDFEncrypted(file.data);
          if (PDFEncrypted) {
            showToast("info", `fileIsProtected|{fileName:${file.fileName}}`);
            isEncrypted = true;
          }
        }
        const rawName = _sliceInstanceProperty(_context2 = file.fileName.split(".")).call(_context2, 0, -1).join(".");
        await putS3Data(file.data, file.url, file.type);
        const {
          applicationDocumentId,
          documentNumber
        } = await markUploadCompleted(applicationId.toString(), classification.classification, classification.description, file.documentId, classification.documentRequestId, isEncrypted);
        const now = moment().toISOString();
        const newDocument = {
          applicationDocumentId,
          classificationType: classification.classification,
          comments: [],
          createdAt: now,
          description: classification.description,
          documentId: file.documentId,
          documentNumber: documentNumber,
          documentRequestId: classification.documentRequestId,
          documentStatus: "active",
          fileName: `${rawName}.pdf`,
          isSample: false,
          requestClassification: classification.classification,
          requestCreatedAt: "",
          requestStatus: "outstanding",
          requestUpdatedAt: "",
          requestedAt: "",
          sent: false,
          updatedAt: now
        };
        context.commit(ADD_DOCUMENTS_TO_CLASSIFICATION, {
          applicationId,
          documentRequestId: newDocument.documentRequestId,
          documents: [newDocument]
        });
        newDocuments.push(newDocument);
      }
      if (newDocuments.length > 0) {
        if (notifyUser) showToast("success", "documentReceived");
        return {
          newDocuments,
          withError: false
        };
      }
    } catch (e) {
      if (notifyUser) Err.handle(e);
      return {
        withError: true
      };
    }
  },
  [UPDATE_DOCUMENT_STATUS]: async (context, {
    applicationId,
    clientUsername,
    documentId,
    documentNumber,
    documentRequestId,
    requestStatus
  }) => {
    const document = context.state.documents.byApplication[applicationId].byId[documentId];
    try {
      context.commit(EDIT_DOCUMENT_DETAILS, {
        applicationId,
        document: {
          documentId,
          requestStatus
        }
      });
      await updateDocumentStatus(applicationId, clientUsername, documentRequestId, documentNumber, requestStatus);
    } catch (e) {
      context.commit(EDIT_DOCUMENT_DETAILS, {
        applicationId,
        documentRequestId,
        document: {
          documentId,
          requestStatus: document.requestStatus
        }
      });
      Err.handle(e);
    }
  },
  [UPLOAD_DOCUMENT_TO_REQUEST_CLASSIFICATION]: async (context, {
    documentRequest,
    files
  }) => {
    try {
      for (const file of files) {
        var _context3, _context4;
        const name = _replaceAllInstanceProperty(_context3 = file.name).call(_context3, " ", "-");
        const rawName = _sliceInstanceProperty(_context4 = name.split(".")).call(_context4, 0, -1).join(".");
        const signed = await getSignedURL(name);
        await putS3Data(file, signed.url, signed.contentType);
        const {
          documentNumber
        } = await markDocumentRequestUploadCompleted(documentRequest.id, signed.documentId);
        const now = moment().format();
        const newDocument = {
          documentNumber,
          classificationType: documentRequest.classification,
          createdAt: now,
          description: "",
          documentId: signed.documentId,
          documentRequestId: documentRequest.id,
          fileName: `${rawName}.pdf`,
          updatedAt: now
        };
        context.commit(ADD_DOCUMENT_TO_REQUEST_CLASSIFICATION, {
          documentRequestId: documentRequest.id,
          document: newDocument
        });
      }
    } catch (e) {
      Err.handle(e);
    }
  },
  [UPDATE_DOCUMENT_CLASSIFICATION_SENT_STATUS]: (context, {
    applicationId,
    documentRequestId,
    sent
  }) => {
    const requestedAt = moment().format();
    context.commit(SET_DOCUMENT_CLASSIFICATION_SENT_STATUS, {
      applicationId,
      documentRequestId,
      sent,
      requestedAt
    });
  },
  [DELETE_DOCUMENT_FROM_CLASSIFICATION]: async (context, {
    applicationId,
    documentId,
    documentRequestId
  }) => {
    const document = context.state.documents.byApplication[applicationId].byId[documentId];
    try {
      context.commit(REMOVE_DOCUMENT_FROM_CLASSIFICATION, {
        applicationId,
        documentId,
        documentRequestId
      });
      await deleteDocument(documentId);
    } catch (e) {
      context.commit(ADD_DOCUMENTS_TO_CLASSIFICATION, {
        applicationId,
        documentRequestId,
        documents: [document]
      });
      Err.handle(e);
    }
  }
};
export default actions;